import { createSelector } from 'reselect'
import { getActiveRole } from 'utils/token'
import { ROLES } from 'constants/enums'
import { get } from 'lodash'

const activeOrganization = state => get(state, 'auth.organization')

const isTopUser = org => {
  return org &&
    (getActiveRole(org) === ROLES.IF_STAFF_SUPER.u ||
    getActiveRole(org) === ROLES.NAO_STAFF.u ||
    getActiveRole(org) === ROLES.GBT.u)
}

export default createSelector(
  activeOrganization,
  isTopUser
)
